<template>
    <b-alert show :variant="variant" class="text-center">
        <h5 class="alert-heading" v-html="msg"></h5>
    </b-alert>
</template>

<script>
    import _ from "lodash";
    import Diagnosis from "../Diagnosis";

    export default {
        props: {
            data: {
                type: Object,
            }
        },
        computed: {
            msg: function () {
                return this.find().msg;
            },
            variant: function () {
                return this.find().variant;
            },
        },
        data() {
            return {
                display: Diagnosis.data().baseTestTraining
            }
        },
        methods: {
            find() {
                let vm = this;

                let kyadMuscleLevelRate = _.find(Diagnosis.data().muscleLevel, function (d) {
                    return d.is(vm.data.out.kyadMuscleLevel);
                }).rate;
                let ksdMuscleLevelRate = _.find(Diagnosis.data().muscleLevel, function (d) {
                    return d.is(vm.data.out.ksdMuscleLevel);
                }).rate;
                let sopMuscleLevel = _.find(Diagnosis.data().sopMuscleLevel, function (d) {
                    return d.is(vm.data.out.sopMuscleLevel);
                }).rate;
                let minMuscleLevel = Math.min(kyadMuscleLevelRate, ksdMuscleLevelRate, sopMuscleLevel);
                kyadMuscleLevelRate = Math.min(minMuscleLevel + 1, kyadMuscleLevelRate);
                ksdMuscleLevelRate = Math.min(minMuscleLevel + 1, ksdMuscleLevelRate);
                sopMuscleLevel = Math.min(minMuscleLevel + 1, sopMuscleLevel);

                return _.find(Diagnosis.data().baseTestTraining, function (d) {
                    return d.is(kyadMuscleLevelRate, ksdMuscleLevelRate, sopMuscleLevel, vm.data.out.odv);
                });
            }
        }
    }
</script>